export interface IWatchDogConfig {
  ignoreDurationMs: number;
  shouldStopPlayer: boolean;
}

export const defaultWatchDogConfig: IWatchDogConfig = {
  ignoreDurationMs: 5000,
  shouldStopPlayer: false,
};
